export function isEmiratesIdValid(params: any[]): boolean {
    const emiratesId = params[0];

    // Check if it's a string and matches the format: 784-XXXX-XXXXXXX-X
    if (typeof emiratesId !== 'string' || !/^784-\d{4}-\d{7}-\d$/.test(emiratesId)) {
        return false;
    }

    // Remove hyphens
    const numbers = emiratesId.replace(/-/g, '');

    // Luhn algorithm implementation
    let sum = 0;
    let alternate = false;

    // Start from second-to-last digit and move right to left
    for (let i = numbers.length - 2; i >= 0; i--) {
        let digit = parseInt(numbers.charAt(i), 10);

        if (alternate) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }

        sum += digit;
        alternate = !alternate;
    }

    // Check if the checksum matches the last digit
    const checksum = (10 - (sum % 10)) % 10;
    const lastDigit = parseInt(numbers.charAt(numbers.length - 1), 10);

    return checksum === lastDigit;
}
